import '../IdcGlobal.IBP.Web/theme/US/site_1/css/normalize.css'
import '../IdcGlobal.IBP.Web/theme/US/site_1/css/material-idc-optimized.css'
import '../IdcGlobal.IBP.Web/theme/US/site_1/css/mdl-selectfield.css'
import '../IdcGlobal.IBP.Web/theme/US/site_1/css/material-agora.css'
import '../../Agora 4.0/IdcGlobal.Agora.JavaScript.PlugIn/AgoraMenu.css'
import '../IdcGlobal.IBP.Web/theme/US/site_1/css/items.style.css'
import '../IdcGlobal.IBP.Web/theme/US/site_1/css/controls.style.css'
import '../../Agora 4.0/IdcGlobal.Agora.JavaScript.PlugIn/jquery2.1.1.js'
import '../IdcGlobal.IBP.Web/js/material.js'
import '../IdcGlobal.IBP.Web/js/mdl-selectfield.js'
import '../../Agora 4.0/IdcGlobal.Agora.JavaScript.PlugIn/AjaxScroller.js'
import '../../Agora 4.0/IdcGlobal.Agora.JavaScript.PlugIn/AgoraMenu.js'
import '../../Agora 4.0/IdcGlobal.Agora.JavaScript.PlugIn/Contact1.1.js'
import '../../Agora 4.0/IdcGlobal.Agora.JavaScript.PlugIn/Utility.js'
import '../IdcGlobal.IBP.Web/js/tinycolor.js'
import '../IdcGlobal.IBP.Web/js/common.js'
